import React from 'react'
import cn from 'classnames'
import {
  WbSelectControl,
  WbSelect,
  WbControlHint,
  WbControlError,
} from '@workbench/react/dist'
import classes from './Select.module.scss'

interface SelectProps {
  id?: string
  label?: string
  hint?: string
  error?: string
  disabled?: boolean
  className?: string
  children: React.ReactElement<JSX.IntrinsicElements['option']>[]
}

export const Select: React.FunctionComponent<
  SelectProps & JSX.IntrinsicElements['select']
> = ({
  id,
  label,
  hint,
  error,
  disabled,
  children,
  className,
  ...selectProps
}) => (
  <WbSelectControl className={cn(classes.select, className)}>
    <WbSelect>
      <label htmlFor={id}>{label}</label>
      <select id={id} {...selectProps} disabled={disabled}>
        {children}
      </select>
    </WbSelect>

    {hint && <WbControlHint>{hint}</WbControlHint>}
    {error && <WbControlError>{error}</WbControlError>}
  </WbSelectControl>
)
